import React          from 'react'
import { Spin, Button }       from 'antd'
import { Droppable }  from 'react-beautiful-dnd'
import FileItem       from './file-item'
import EmptyState     from '../../Shared/EmptyState/index'
import InfiniteScroll from 'react-infinite-scroller'

import './styles.scss'

let scrollParentRef;

export default ({files, any_cloud_accounts, files_loading, selection_count, dragging_id,
                  accounts_loading, on_select, on_play_video, has_more, droppable_id, is_drop_disabled, is_drag_disabled,
                  on_download, on_delete, on_share, on_open_encode, on_open_hybrik, on_show_media_info,
                  on_expand_options, on_refresh, on_navigate, on_load_more, on_move, user
}) => (
  <Droppable droppableId={droppable_id} isDropDisabled={is_drop_disabled}>
    {(provided, snapshot) =>
      (
        <div className={'files'}
             ref={provided.innerRef}
             style={{backgroundColor: snapshot.isDraggingOver ? 'gainsboro' : ''}}
             {...provided.droppableProps}>{
          (files_loading && (!files || files.length === 0)) ?
            <Spin size='small' tip='Loading...' style={{padding: '15% 50%', margin: '0 auto'}}/> :
            ((!files || files.length === 0) ?
                <EmptyState on_click={on_refresh}
                            title={(!accounts_loading && !any_cloud_accounts) ? 'No cloud account found' : 'No file found'}/> : [
                                
                                (<FilesView
                                    files             = {files}
                                    hasMore           = {has_more}
                                    droppableId       = {droppable_id}
                                    selectionCount    = {selection_count}
                                    isDragDisabled    = {is_drag_disabled}
                                    user              = {user}
                                    key               = {'FilesView'}
                                    onPlayVideo       = {on_play_video}
                                    onSelect          = {on_select}
                                    onDownload        = {on_download}
                                    onDelete          = {on_delete}
                                    onShare           = {on_share}
                                    onOpenEncode      = {on_open_encode}
                                    onShowMediaInfo   = {on_show_media_info}
                                    onOpenHybrik      = {on_open_hybrik}
                                    onExpandOptions   = {on_expand_options}
                                    onNavigate        = {on_navigate}
                                    onMove            = {on_move}
                                    onLoadMore        = {on_load_more}
                                />)

                ]
            )
        }
          {provided.placeholder}
        </div>
      )}
  </Droppable>
)

class FilesView extends React.Component {
    constructor(props){
        super(props)
    }
    

    render(){

      // console.log("fileshvishfoirehroihioh ", this.props);
        const {files, droppableId,draggingId, selectionCount, hasMore, onLoadMore, isGhosting, isDragDisabled, onPlayVideo, onSelect, onDownload, onDelete, onShare, onOpenEncode, onShowMediaInfo, onOpenHybrik, onExpandOptions, onNavigate, onMove, user } = this.props

        return (
                <div
                        className="files-view-container"
                        ref={ref => (this.scrollParentRef = ref)}>
                        <InfiniteScroll
                        initialLoad={false}
                        pageStart={0}
                        loadMore={onLoadMore}
                        hasMore={hasMore}
                        useWindow={false}
                        getScrollParent={() => this.scrollParentRef}>
            <div>
                        <div>
                        {files.map((file, index) =>
                            <FileItem key                = {index}
                            index              = {index}
                            file               = {file}
                            droppable_id       = {droppableId}
                            selection_count    = {selectionCount}
                            is_ghosting        = {file.checked && draggingId && draggingId !== (file.basename || file.key)}
                            is_drag_disabled   = {isDragDisabled}
                            on_play_video      = {onPlayVideo}
                            on_select          = {onSelect}
                            on_download        = {onDownload}
                            on_delete          = {onDelete}
                            on_share           = {onShare}
                            on_open_encode     = {onOpenEncode}
                            on_show_media_info = {onShowMediaInfo}
                            on_open_hybrik     = {onOpenHybrik}
                            on_expand_options  = {onExpandOptions}
                            on_navigate        = {onNavigate}
                            on_move            = {onMove}
                            user               = {user}
                            />)}
    </div>

    <div className="load-more">{hasMore && <Button type="primary" onClick={() => onLoadMore()}>Load More </Button>}</div>
    </div>
            </InfiniteScroll>
        </div>
        )
    }
}

